import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { UserChoices } from '@features/loan/interfaces';
import {
  Catalog,
  ConnectedSimulation,
  LoanCharacteristics,
  NotConnectedSimulation,
  SavedSimulationConfirmation,
} from '@features/loan/models';
import { PublishablesAreas } from '@features/loan/models/publishables-areas-response.model';

export const getPublishablesAreasActions = createActionGroup({
  source: 'get publishables areas',
  events: {
    load: emptyProps(),
    'load Completed': props<{
      areas: PublishablesAreas;
    }>(),
  },
});

export const getCatalogActions = createActionGroup({
  source: 'get catalog',
  events: {
    load: emptyProps(),
    'load Completed': props<{
      catalog: Catalog;
    }>(),
    'load Failed': props<{ error: HttpErrorResponse }>(),
  },
});

export const createLoanActions = createActionGroup({
  source: 'create loan',
  events: {
    Post: props<{
      loanItemId: string;
      userChoices: UserChoices;
      mobility4YouParams?: { partnerId: string; partnerProjectId: string };
    }>(),
    'Post Completed': props<{ creationResponse: LoanCharacteristics; userChoices: UserChoices }>(),
    'Post Failed': props<{ errorCode: number; errorMsg: string }>(),
  },
});

export const mobility4YouActions = createActionGroup({
  source: 'mobility4you',
  events: {
    'Invalid params': emptyProps(),
  },
});

export const getSimulationForConnectedCustomerActions = createActionGroup({
  source: 'connected customers simulation',
  events: {
    load: props<{
      projectId: string;
      userChoices: UserChoices;
    }>(),
    'load Completed': props<{ connSimulResponse: ConnectedSimulation }>(),
    'load Failed': props<{ error: HttpErrorResponse }>(),
  },
});

export const getSimulationForNotConnectedUserActions = createActionGroup({
  source: 'not connected customers simulation',
  events: {
    load: props<{
      loanItemId: string;
      userChoices: UserChoices;
    }>(),
    'load Completed': props<{ notConnSimulResponse: NotConnectedSimulation }>(),
    'load Failed': props<{ error: HttpErrorResponse }>(),
  },
});

export const saveSimulationActions = createActionGroup({
  source: 'save simulation',
  events: {
    load: props<{
      projectId: string;
      simulationReference: string;
      isSingleBorrower: boolean;
    }>(),
    'load Completed': props<{ response: SavedSimulationConfirmation }>(),
    'load Failed': props<{ error: HttpErrorResponse }>(),
  },
});

export const jointCaseCreateLoanActions = createActionGroup({
  source: 'joint case create loan',
  events: {
    load: props<{
      loanItemId: string;
      userChoices: UserChoices;
      mobility4YouParams?: { partnerId: string; partnerProjectId: string };
    }>(),
    'load Completed': props<{
      creationResponse: LoanCharacteristics;
      userChoices: UserChoices;
    }>(),
    'load Failed': props<{ errorCode: number; errorMsg: string }>(),
  },
});

export const jointCaseGetSimulationActions = createActionGroup({
  source: 'joint case get simulation',
  events: {
    load: props<{
      projectId: string;
      userChoices: UserChoices;
    }>(),
    'load Completed': props<{ connSimulResponse: ConnectedSimulation }>(),
    'load Failed': props<{ error: HttpErrorResponse }>(),
  },
});

export const createLoanPostConnectionActions = createActionGroup({
  source: 'create loan post connection',
  events: {
    load: props<{
      loanItemId: string;
      userChoices: UserChoices;
    }>(),
    'load Completed': props<{ creationResponse: LoanCharacteristics; userChoices: UserChoices }>(),
    'load Failed': props<{ errorCode: number; errorMsg: string }>(),
    'load Failed 401': emptyProps(),
  },
});

export const getSimulationForConnectedCustomerPostConnectionActions = createActionGroup({
  source: 'connected customers simulation post connection',
  events: {
    load: props<{
      projectId: string;
      userChoices: UserChoices;
    }>(),
    'load Completed': props<{ connSimulResponse: ConnectedSimulation }>(),
    'load Failed': props<{ error: HttpErrorResponse }>(),
  },
});
